import React from 'react';
import { MessageCircle, X, Phone, Clock, MessageSquare } from 'lucide-react';
import { useToggleAnimation, getAnimationClasses, getAnimationStyles } from '../hooks/useToggleAnimation';
import { WHATSAPP_URL, trackWhatsAppClick } from '../analytics';
import './AnimatedFloatingWhatsApp.css';

const AnimatedFloatingWhatsApp = () => {
  const { isOpen, isAnimating, toggle, autoClose } = useToggleAnimation(false, 300);

  const handleQuickAction = (action) => {
    trackWhatsAppClick(window.location.pathname + window.location.search + window.location.hash);
    window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
    autoClose(500);
  };

  return (
    <div className={`animated-floating-whatsapp ${getAnimationClasses(isOpen, isAnimating, 'floating-wrapper')}`}>
      {/* Main Floating Button */}
      <button
        className={`floating-main-btn ${getAnimationClasses(isOpen, isAnimating, 'main-btn')}`}
        onClick={toggle}
        disabled={isAnimating}
        aria-label={isOpen ? "Tutup Customer Service" : "Buka Customer Service"}
      >
        <div className="btn-icon">
          {isOpen ? <X size={20} /> : <MessageCircle size={20} />}
        </div>
        <span className="btn-text">Chat</span>
        <div className="status-dot"></div>
      </button>

      {/* Modern Popup */}
      <div 
        className={`modern-popup ${getAnimationClasses(isOpen, isAnimating, 'popup')}`}
        style={getAnimationStyles(isOpen, isAnimating)}
      >
        {/* Popup Header */}
        <div className="popup-header">
          <div className="header-left">
            <div className="status-indicator">
              <div className="status-dot"></div>
              <span className="status-text">Online</span>
            </div>
            <h3 className="header-title">Customer Service Online</h3>
          </div>
          <button 
            className="close-btn"
            onClick={toggle}
            disabled={isAnimating}
          >
            <X size={16} />
          </button>
        </div>

        {/* Popup Content */}
        <div className="popup-content">
          <div className="welcome-section">
            <h4 className="welcome-title">Butuh bantuan?</h4>
            <p className="welcome-subtitle">Kami siap membantu Anda 24/7</p>
          </div>

          <div className="action-buttons">
            <button 
              className="action-btn primary"
              onClick={() => handleQuickAction('chat')}
              disabled={isAnimating}
            >
              <MessageSquare size={16} />
              <span>Chat Sekarang</span>
            </button>
            
            <button 
              className="action-btn secondary"
              onClick={() => handleQuickAction('consultation')}
              disabled={isAnimating}
            >
              <Phone size={16} />
              <span>Konsultasi Gratis</span>
            </button>
          </div>

          <div className="info-section">
            <div className="info-item">
              <Clock size={14} />
              <span>Respon &lt; 5 menit</span>
            </div>
            <div className="info-item">
              <MessageCircle size={14} />
              <span>Support via WhatsApp</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedFloatingWhatsApp;
